export default function PaymentOptionButton({
  label,
  color,
  onClick,
}: {
  label: string;
  color: string;
  onClick: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className={`w-full px-5 py-3 rounded-xl text-white ${color} hover:opacity-90`}
    >
      {label}
    </button>
  );
}